import { File } from '../../../modules/file/model'
import { Service } from '../../../modules/config/model'

export const shouldDisplayThumbnail = (file: File, service: Service): boolean => service === Service.Ulozto || !!file.preview

export const isFile = (item: File | undefined): boolean => item != undefined && 'name' in item
